import KenAll from "ken-all";
export function initOnlineRegistrationForm() {
    // オンライン登録フォームでなければ何もしない
    const onlineRegistrationForm = document.querySelector("[data-online-register-form-section]");
    if (!onlineRegistrationForm)
        return;
    initSearchAddressButton(onlineRegistrationForm);
    initInsertVerifiedAt();
}
// 住所検索ボタンの初期化
function initSearchAddressButton(onlineRegistrationForm) {
    const searchAddressButton = onlineRegistrationForm.querySelector("[data-search-address]");
    if (!searchAddressButton)
        throw new Error("'searchAddressButton' is not found");
    searchAddressButton.addEventListener("click", () => {
        // 入力された郵便番号から住所を検索し、都道府県と住所１に返されたデータを挿入する
        const firstPostalCode = onlineRegistrationForm.querySelector("[data-fist-postal-code]").value;
        if (firstPostalCode === null || firstPostalCode.length !== 3)
            return;
        const lastPostalCode = onlineRegistrationForm.querySelector("[data-last-postal-code]").value;
        if (lastPostalCode === null || lastPostalCode.length !== 4)
            return;
        const searchPostalCode = firstPostalCode + lastPostalCode;
        KenAll(searchPostalCode).then((result) => {
            if (result.length === 0)
                return;
            const prefecture = result[0].shift();
            const insertText = result[0].join("");
            const prefectureInputElement = onlineRegistrationForm.querySelector("[data-prefecture-input]");
            if (!prefectureInputElement)
                throw new Error("'prefectureInputElement' is not found");
            for (const prefectureOption of prefectureInputElement.options) {
                if (prefectureOption.text === String(prefecture)) {
                    prefectureOption.selected = true;
                }
            }
            const addressInputElement = onlineRegistrationForm.querySelector("[data-address-input]");
            addressInputElement.value = insertText;
        });
    });
}
// メール認証日時をユーザー側で変更できないように登録ボタンを押したタイミングで挿入する
function initInsertVerifiedAt() {
    const now = new Date();
    const month = now.getMonth() + 1;
    const verifiedDatetimeString = now.getFullYear() + "-" + month + "-" + now.getDate() + " " + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds();
    const registerButton = document.querySelector("[data-register-button]");
    if (!registerButton)
        throw new Error("'registerButton' is not found");
    registerButton.addEventListener("click", function () {
        const verifiedAtInputElement = document.querySelector("[data-insert-verified-at]");
        if (!verifiedAtInputElement)
            throw new Error("'verifiedAtInputElement' is not found");
        verifiedAtInputElement.value = verifiedDatetimeString;
    });
}
